import backgroundLandingImg from "../../../../assets/background-landing.png";

const ContactNavHeader = () => {
  return (
    // <section className="text-center  px-6 md:px-0 bg-[#6E3FC6] text-white py-16  shadow-lg">

    //   <h1 className="text-3xl md:text-3xl leading-snug">
    //    <br />
    //     <span >contact</span>
    //   </h1>
    //   <p className="mt-6 text-sm md:text-base text-[#e0dfff] font-normal">
    //    the latest industry news, interviews, technologies and resources.
    //   </p>
    // </section>
     <section
      className="relative w-full bg-[#6E3FC6] bg-cover bg-center bg-no-repeat py-20 md:py-20 px-6 text-center font-[Lexend] mt-8 sm:mt-10 md:mt-14 min-h-[150px]"
      style={{ backgroundImage: `url(${backgroundLandingImg})` }}
    >
      {/* Background overlay */}
      <div className="absolute inset-0 bg-[#6E3FC6]/65 pointer-events-none"></div>

      {/* ✅ Content Wrapper with extra top padding */}
      <div className="relative max-w-[1000px] mx-auto">
        <h1 className="font-semibold text-[26px] sm:text-[24px] md:text-[42px] lg:text-[48px] lowercase text-white leading-[50px] mb-2">
         <span >contact</span>
        </h1>
        {/* <p className=" text-[#e0dfff] text-base md:text-lg font-normal max-w-[600px] mx-auto">
          the latest industry news, interviews, technologies and resources.
        </p> */}
      </div>
    </section>
  );
};

export default ContactNavHeader;